module.exports = __webpack_public_path__ + "static/media/client-info.e3230e55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/client-info.jpg
// module id = 385
// module chunks = 0